export default __webpack_public_path__ + "static/media/gallery_00.1fc032ca.jpg";